import { changeLineStatus } from '@/redux/actions/brands'
import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

interface MenuProps {
  line: {
    id: string
    status: number
  }
  onDelete: (id: string) => void
  onToggleStatus: (id: string) => void
}

export const LineActionsMenu: React.FC<MenuProps> = ({ line, onDelete, onToggleStatus }) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleToggleStatus = async () => {
    await dispatch(changeLineStatus(line.id))
    onToggleStatus(line.id)
    handleClose()
  }

  const handleDelete = () => {
    onDelete(line.id)
    handleClose()
  }

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuItem onClick={handleToggleStatus}>
          <ListItemText>{line.status === 1 ? t('inactivate') : t('activate')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <ListItemText>{t('delete')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  )
}
